import React, { useEffect, useState } from 'react';
import { createTaskTag, getApiErrorMessage, listTaskTags, updateTaskTag } from '../../services/tasksAPI';
import type { TaskTag } from '@/shared/types/taskQueue.types';
import './TaskQueue.css';

const TaskTagsAdmin: React.FC = () => {
  const [tags, setTags] = useState<TaskTag[]>([]);
  const [newName, setNewName] = useState('');
  const [message, setMessage] = useState('');

  const load = (): void => {
    listTaskTags()
      .then(setTags)
      .catch((err: unknown) => setMessage(getApiErrorMessage(err)));
  };

  useEffect(load, []);

  const addTag = async (): Promise<void> => {
    if (!newName.trim()) return;
    try {
      await createTaskTag(newName.trim());
      setNewName('');
      load();
    } catch (err: unknown) {
      setMessage(getApiErrorMessage(err));
    }
  };

  const retire = async (tag: TaskTag): Promise<void> => {
    try {
      await updateTaskTag(tag.id, { retired: true });
      load();
    } catch (err: unknown) {
      setMessage(getApiErrorMessage(err));
    }
  };

  return (
    <div className="task-queue-page">
      <h1>Task tags</h1>
      {message ? <p className="task-message">{message}</p> : null}
      <div className="task-form">
        <label>
          New tag name
          <input value={newName} onChange={(e) => setNewName(e.target.value)} />
        </label>
        <button type="button" className="primary" onClick={() => void addTag()}>
          Add tag
        </button>
      </div>
      <table className="task-admin-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Retired</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {tags.map((tag) => (
            <tr key={tag.id}>
              <td>{tag.name}</td>
              <td>{tag.retired ? 'yes' : 'no'}</td>
              <td>
                {!tag.retired ? (
                  <button type="button" onClick={() => void retire(tag)}>
                    Retire
                  </button>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TaskTagsAdmin;
